export const getFormattedTime = (time: number): string => {
  const mm = Math.floor(time / 60);
  const ss = time - mm * 60;

  return [mm, ss].map((x) => `${x}`.padStart(2, '0')).join(':');
};
